import React, { useState } from 'react';
import PageNavigation from './PageNavigation';
import ImageModal from './ImageModal';
import './DocumentPreview.css';

function DocumentPreview({ images, loading, metadata }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  if (loading) {
    return (
      <div className="preview-container">
        <div className="preview-loading">
          <div className="preview-spinner"></div>
          <p>Cargando vista previa...</p>
        </div>
      </div>
    );
  }

  if (!images || images.length === 0) {
    return (
      <div className="preview-container">
        <div className="preview-empty">
          <p>Sin vista previa disponible</p>
        </div>
      </div>
    );
  }

  const currentImage = images[currentPage];

  return (
    <div className="preview-container">
      <div className="preview-image-wrapper" onClick={() => setModalOpen(true)}>
        <img
          src={`data:image/jpeg;base64,${currentImage.base64}`}
          alt={`Pagina ${currentImage.page_number}`}
          className="preview-image"
        />
        <div className="preview-overlay">
          <span>Click para ampliar</span>
        </div>
      </div>

      <PageNavigation
        currentPage={currentPage}
        totalPages={images.length}
        onPageChange={setCurrentPage}
        pageNumbers={images.map(img => img.page_number)}
      />

      {modalOpen && (
        <ImageModal
          imageSrc={`data:image/jpeg;base64,${currentImage.base64}`}
          pageNumber={currentImage.page_number}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
}

export default DocumentPreview;
